
import FeedbackResponses from '~/components/brokerage-hr/FeedbackResponses.vue'
import { SCORE_COLUMNS, cleanParams, defaultRange, formatNps, formatScore } from '~/util/brokerage-hr'

export default {
    components: { FeedbackResponses },
    data () {
        return {
            filters: { ...defaultRange(), source: 'all' },
            sourceOptions: [
                { value: 'all', text: 'Both' },
                { value: 'flow', text: 'Flow' },
                { value: 'jotform', text: 'Jotform' },
            ],
            scoreColumns: SCORE_COLUMNS,
            summary: null,
            loading: false,
            selected: null,
            requestId: 0,
        }
    },
    computed: {
        tableRows () {
            if (!this.summary) return []
            const rows = this.summary.advisors.map(advisor => ({
                key: `a${advisor.agent_id}`, name: advisor.name, block: advisor, agent: advisor.agent_id,
            }))
            if (this.summary.unattributed) {
                rows.push({ key: 'unattributed', name: 'Unattributed', block: this.summary.unattributed, agent: 'unattributed' })
            }
            rows.push({ key: 'total', name: 'Brokerage total', block: this.summary.total, isTotal: true })
            return rows
        },
        selectedKey () { return this.selected ? this.selected.key : null },
    },
    watch: {
        filters: {
            deep: true,
            handler () { this.load() },
        },
    },
    mounted () {
        this.load()
    },
    methods: {
        async load () {
            // An older answer never overwrites a newer one.
            const id = ++this.requestId
            this.loading = true
            const res = await this.$try('getFeedbackSummary', cleanParams(this.filters))
            if (id !== this.requestId) return
            this.loading = false
            if (!res || res.error) return
            this.summary = res
        },
        select (row) {
            if (row.isTotal) return
            this.selected = row
        },
        score (block, key) { return formatScore(block[key]) },
        npsLabel (nps) { return formatNps(nps) },
    },
}
